import React, { useState, version } from "react";
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toastify";

export default function ImageCreatePage() {
    const [name, setName] = useState("");
    const [clusters, setClusters] = useState(() => {
        return JSON.parse(localStorage.getItem("clusters"));
    });
    const [selectedCluster, setSelectedCluster] = useState(clusters[0].id);
    const [type, setType] = useState("distribution");
    const [diskFormat, setDiskFormat] = useState("qcow2");
    const [visibility, setVisibility] = useState("private");
    const [file, setFile] = useState(null);
    const [version, setVersion] = useState(null);
    const [uploading, setUploading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            toast.error("Please upload an image file.");
            return;
        }

        if (!selectedCluster) {
            toast.error("Please select cluster.");
            return;
        }

        const formData = new FormData();
        formData.append("name", name);
        formData.append("cluster_id", selectedCluster);
        formData.append("type_", type);
        formData.append("disk_format", diskFormat);
        formData.append("visibility", visibility);
        formData.append("file", file);
        formData.append("version", version);

        setUploading(true);
        try {
            const res = await axiosInstance.post("/admin/os/images", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            toast.success(
                `Image '${res.data.image_name}' created successfully.`
            );
            setName("");
            setDiskFormat("qcow2");
            setVisibility("private");
            setFile(null);
        } catch (err) {
            toast.error(err.response?.data?.error || "Failed to create image.");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-900 text-white">
            <div className="max-w-3xl mx-auto px-6 py-10">
                <Card title="Create New Image">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Name
                            </label>
                            <input
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                                className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Cluster
                            </label>
                            <select
                                value={selectedCluster}
                                onChange={(e) =>
                                    setSelectedCluster(e.target.value)
                                }
                                className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-600 focus:outline-none"
                            >
                                {clusters.map((cluster) => (
                                    <option key={cluster.id} value={cluster.id}>
                                        {cluster.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Type
                            </label>
                            <select
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                                className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-600 focus:outline-none"
                            >
                                <option value="distribution">
                                    Distribution
                                </option>
                                <option value="marketplace">Marketplace</option>
                                <option value="iso">ISO</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Disk Format
                            </label>
                            <select
                                value={diskFormat}
                                onChange={(e) => setDiskFormat(e.target.value)}
                                className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-600 focus:outline-none"
                            >
                                <option value="qcow2">QCOW2</option>
                                <option value="raw">Raw</option>
                                <option value="vmdk">VMDK</option>
                                <option value="vhd">VHD</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                File
                            </label>
                            <input
                                type="file"
                                accept=".qcow2,.img,.iso,.raw,.vmdk,.vhd"
                                onChange={(e) => setFile(e.target.files[0])}
                                required
                                className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-600 focus:outline-none"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Version
                            </label>
                            <input
                                type="text"
                                value={version}
                                onChange={(e) => setVersion(e.target.value)}
                                required
                                className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Visibility
                            </label>
                            <select
                                value={visibility}
                                onChange={(e) => setVisibility(e.target.value)}
                                className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-600 focus:outline-none"
                            >
                                <option value="private">Private</option>
                                <option value="public">Public</option>
                                <option value="shared">Shared</option>
                                <option value="community">Community</option>
                            </select>
                        </div>
                        <div>
                            <button
                                type="submit"
                                disabled={uploading}
                                className="bg-blue-600 hover:bg-blue-700 transition text-white px-6 py-2 rounded-md disabled:opacity-50"
                            >
                                {uploading ? "Uploading..." : "Create Image"}
                            </button>
                        </div>
                    </form>
                </Card>
            </div>
        </div>
    );
}

function Card({ title, children }) {
    return (
        <div className="bg-gray-800 rounded-lg p-6 shadow-lg border border-gray-700">
            <h3 className="text-lg font-semibold text-white mb-4">{title}</h3>
            {children}
        </div>
    );
}
